package fr.frux.navigation

import androidx.navigation3.runtime.NavKey
import androidx.savedstate.serialization.SavedStateConfiguration
import fr.frux.navigation.Route.AddTree
import fr.frux.navigation.Route.Auth
import fr.frux.navigation.Route.BlockedUsers
import fr.frux.navigation.Route.CreateHarvest
import fr.frux.navigation.Route.CreateSite
import fr.frux.navigation.Route.Favorites
import fr.frux.navigation.Route.Feedback
import fr.frux.navigation.Route.HarvestDetail
import fr.frux.navigation.Route.Harvests
import fr.frux.navigation.Route.Map
import fr.frux.navigation.Route.MoveTree
import fr.frux.navigation.Route.MyTrees
import fr.frux.navigation.Route.NotificationPreferences
import fr.frux.navigation.Route.Notifications
import fr.frux.navigation.Route.Premium
import fr.frux.navigation.Route.Profile
import fr.frux.navigation.Route.Settings
import fr.frux.navigation.Route.Showcase
import fr.frux.navigation.Route.SiteDetail
import fr.frux.navigation.Route.TreeDetail
import fr.frux.navigation.Route.TreeList
import fr.frux.navigation.Route.UserProfile
import fr.frux.navigation.Route.Welcome
import kotlinx.serialization.modules.SerializersModule
import kotlinx.serialization.modules.polymorphic
import kotlinx.serialization.modules.subclass

/**
 * Polymorphic serialization configuration for Navigation 3 UI.
 *
 * This configuration is CRITICAL for non-JVM platforms (iOS, Web) where reflection is not available.
 * Android/Desktop (JVM) use reflection to serialize routes, but iOS/Web need explicit registration.
 *
 * Without this configuration, rememberNavBackStack() will crash on iOS/Web with:
 * "No serializer found for class NavKey"
 *
 * Usage:
 * ```kotlin
 * val backStack = rememberNavBackStack(fruxNavConfig, Route.Map)
 * ```
 *
 * Important: Every time you add a new Route subclass, you MUST register it here. Un oubli plante
 * Android au passage en arrière-plan (`onSaveInstanceState`, #547) : `NavConfigTest` le refuse.
 */
val fruxNavConfig =
    SavedStateConfiguration {
        serializersModule =
            SerializersModule {
                polymorphic(NavKey::class) {
                    // Register all Route subclasses for polymorphic serialization
                    subclass(Welcome::class)
                    subclass(Auth::class)
                    subclass(Map::class)
                    subclass(Harvests::class)
                    subclass(MyTrees::class)
                    subclass(Favorites::class)
                    subclass(Settings::class)
                    subclass(TreeList::class)
                    subclass(Profile::class)
                    subclass(TreeDetail::class)
                    subclass(HarvestDetail::class)
                    subclass(UserProfile::class)
                    subclass(Showcase::class)
                    subclass(AddTree::class)
                    subclass(MoveTree::class)
                    subclass(CreateHarvest::class)
                    subclass(Notifications::class)
                    subclass(NotificationPreferences::class)
                    subclass(Feedback::class)
                    subclass(Premium::class)
                    subclass(BlockedUsers::class)
                    subclass(SiteDetail::class)
                    subclass(CreateSite::class)
                }
            }
    }
